import {
  addToJobQueue,
  clearJobQueue,
  showGlobalAlert,
} from "slices/app/appSlice";
import localhost from "apis/localhost";
import { showErrorModal } from "slices/app/actions/error";
import { modalTypes } from "constants/types";
import { DEFAULT_SETTINGS } from "constants/readabilityThresholds";
import { hideModal } from "slices/app/actions/modals";
import { alertVariants } from "@visiblethread/react-components/dist/components/Alert";
import { setThresholds } from "slices/settings/slices/thresholdsSlice";

export const fetchThreshold = () => async (dispatch) => {
  dispatch(addToJobQueue("genericJob"));

  await localhost
    .get("/docs/readabilityThreshold/")
    .then((response) => {
      const { data } = response;
      dispatch(setThresholds(data));
    })
    .catch((error) => {
      dispatch(showErrorModal(error));
    })
    .finally(() => {
      dispatch(clearJobQueue());
    });
};

export const editThreshold =
  (readabilityThresholdSettings) => async (dispatch) => {
    dispatch(addToJobQueue("genericJob"));

    await localhost
      .post("/docs/readabilityThreshold/edit/", {
        ...readabilityThresholdSettings,
      })
      .then((response) => {
        const { data } = response;
        dispatch(setThresholds(data));
        dispatch(
          showGlobalAlert({
            variant: alertVariants.success,
            text: "Readability settings successfully updated",
          })
        );
      })
      .catch((error) => {
        dispatch(showErrorModal(error));
      })
      .finally(() => {
        dispatch(hideModal(modalTypes.RESET_DEFAULTS_THRESHOLDS));
        dispatch(clearJobQueue());
      });
  };

export const resetDefaults = () => async (dispatch) => {
  dispatch(editThreshold({ ...DEFAULT_SETTINGS }));
};
